module.exports = __webpack_public_path__ + "static/media/img_qudao8@2x.a54434f6.png";